import { HttpService } from "../../services/http.service";
import type { VILCOpportunitiesComponent } from "./vilc-opportunities.component";
import type { VilcWorkflowDependencies } from "./vilc-opportunities-workflow-dependencies";

type VilcRequestsWorkflowContext = Pick<
  VILCOpportunitiesComponent,
  | "onFileUploadCancel"
  | "expId"
  | "commonApiCall"
  | "showValidationError"
  | "validationData"
  | "buttonDisabled"
  | "pollingApiCall"
  | "showDialogLoader"
  | "showModifyDialog"
  | "refreshVilcOpportunities"
>;
export class VilcRequestsWorkflow {
  commonFileApiCall(
    context: VilcRequestsWorkflowContext,
    dependencies: VilcWorkflowDependencies,
    apiUrl: string,
    method: string,
    params: any,
    callback: (response: any, params: any) => void,
  ): void {
    dependencies.httpService[method as keyof HttpService](
      apiUrl,
      params,
    ).subscribe(
      (response: any) => {
        if (response) {
          // common callback function for response
          callback(response, params);
        }
      },
      (err: any) => {
        if (err.status === 400) {
          dependencies.messageService.add({
            key: "w",
            severity: "warn",
            summary: "Something went wrong!",
            detail: err.error.message,
            sticky: true,
          });
        } else if (err.status !== 401) {
          dependencies.messageService.clear();
          dependencies.messageService.add({
            key: "c",
            severity: "warn",
            summary: err.error.message,
            detail: err.error.traceback,
            sticky: true,
          });
        }
        context.onFileUploadCancel("null");
        dependencies.stateService.removeCalledApi(apiUrl);
      },
    );
  }
  commonApiCall(
    _context: VilcRequestsWorkflowContext,
    dependencies: VilcWorkflowDependencies,
    apiUrl: string,
    method: string,
    params: any,
    callback: (response: any, params: any) => void,
    extraFlag: any = {},
  ): void {
    dependencies.httpService[method as keyof HttpService](
      apiUrl,
      params,
    ).subscribe(
      (response: any) => {
        if (response) {
          // common callback function for response
          response["extra_flag"] = extraFlag;
          callback(response, params);
        }
      },
      (err: any) => {
        if (err.status === 400) {
          dependencies.messageService.add({
            key: "w",
            severity: "warn",
            summary: "Something went wrong!",
            detail: err.error.message,
            sticky: true,
          });
        } else if (err.status !== 401) {
          dependencies.messageService.clear();
          dependencies.messageService.add({
            key: "c",
            severity: "warn",
            summary: err.error.message,
            detail: err.error.traceback,
            sticky: true,
          });
        }
        dependencies.stateService.removeCalledApi(apiUrl);
      },
    );
  }
  runValidationAPI(
    context: VilcRequestsWorkflowContext,
    dependencies: VilcWorkflowDependencies,
    method: string,
  ): void {
    const apiUrl =
      dependencies.stateService.apiList.experiments.runDTPValidation(
        context.expId,
        "dtp_vilc",
      );

    // Call the API using commonApiCall method
    context.commonApiCall(apiUrl, method, {}, (response: any, _params: any) => {
      if (method === "getMethod") {
        context.showValidationError = true;
        context.validationData["vilc"] = JSON.parse(response.result).result[
          "vilc"
        ];
        const hasRedError = Object.values(context.validationData["vilc"])
          .filter((value) => Array.isArray(value)) // only process sections with arrays
          .flat()
          .some((item: any) => item.level === "red");
        context.buttonDisabled = hasRedError;
      } else if (method === "postMethod") {
        context.pollingApiCall(response?.task_id);
      }
    });
  }
  editModifyProceed(
    context: VilcRequestsWorkflowContext,
    dependencies: VilcWorkflowDependencies,
  ): void {
    context.showDialogLoader = true;
    const apiUrl =
      dependencies.stateService.apiList.experiments.updateVILCForSKU(
        context.expId,
      );
    context.commonApiCall(apiUrl, "postMethod", {}, (response: any) => {
      if (response) {
        context.showDialogLoader = false;
        if (context.showModifyDialog) {
          context.showModifyDialog = false;
        }
        context.onFileUploadCancel();
        context.refreshVilcOpportunities.emit();
      }
    });
  }
}
